import { createFileRoute } from '@tanstack/react-router';
import { CustomClerkSignInForm } from '../components/auth/CustomClerkSignInForm';
import { LoginPageLayout } from '../components/auth/LoginPageLayout';

export const Route = createFileRoute('/login')({
  /** Warm the dotted-map chunk in parallel with the route paint (do not await). */
  loader: () => {
    void import('../components/ui/world-map');
    return undefined;
  },
  component: LoginRouteComponent,
});

function LoginRouteComponent() {
  return (
    <LoginPageLayout>
      <CustomClerkSignInForm
        signUpHref="/signup"
        afterSignInRedirect="/client/orders"
      />
    </LoginPageLayout>
  );
}
